import React, { useEffect, useState } from 'react'
import './PackagesStyles.css'
import { LocalStorageServices } from '../../../../services/localStorageServices';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import CustomTable from '../../../../components/custom_table/CustomTable';
import CustomDeleteConfirmModal from '../../../../components/custom_delete_confirm_modal/CustomDeleteConfirmModal';
import { PiEye } from 'react-icons/pi';
import { BiEditAlt } from 'react-icons/bi';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import { delete_package_by_id, get_package_list, getpackage_lists_with_pagination } from '../../../../api/packageApis';
import { ErrorToast, SuccessToast } from '../../../../toast/toasts';
import PackagesFilter from './packages_filter/PackagesFilter';
import CustomBottomPagination from '../../../../components/custom_bottom_pagination/CustomBottomPagination';
import CancelPackages from './package_modals/CancelPackages';
import { IconButton, Tooltip } from '@mui/material';
import { IoCloseCircleOutline } from 'react-icons/io5';
import { TiTickOutline } from 'react-icons/ti';
import { FaRegCirclePause } from "react-icons/fa6";
import PackagesManagerLevelModal from './packages_manage_level_modals/PackagesManagerLevelModal';
import PackageFinanceLevelModals from './package_finance_level_modals/PackageFinanceLevelModals';
import PackageReusableModals from './package_reusable_modals/PackageReusableModals';
import { SiTicktick } from 'react-icons/si';
import PackageCommentModal from './package_comment_modal/PackageCommentModal';
import { FaRegCommentAlt } from 'react-icons/fa';
import { LiaFileInvoiceSolid } from 'react-icons/lia';
import PackageInvoiceDetailsModal from './package_invoice_details_modal/PackageInvoiceDetailsModal';
import { useDispatch, useSelector } from 'react-redux';
import { hasPrivilege } from '../../../../common_privilige_methods/Privilege_Methods';
import { resetSearchFilter, updateSearchFilter } from '../../../../store/process_ecr/packageStore';

function Packages() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const filter_data_store = useSelector((state) => state.commonStore.notification_redirect)
  const packageStoredValues = useSelector((state) => state.packageStore.package_filter);

  const baseRouteUrl = `/ecrs_portal/${LocalStorageServices.getUserRole()}/process_ecr`

  const [packageListing, setPackageListing] = useState([])
  const [pageNumber, setPageNumber] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [totalItemPerPage, setTotalItemPerPage] = useState(10)

  const [selectedId, setSelectedId] = useState("");
  const [searchFilter, setSearchFilter] = useState(null)
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);


  const [selectedItem, setSelectedItem] = useState(null)
  const [cancelModal, setCancelModal] = useState(false);

  const [financeLevelModal, setfinanceLevelModal] = useState(false)
  const [actionModal, setActionModal] = useState(false)
  const [cfoLevelModal, setCfoLevelModal] = useState(false)

  const [commentModal, setcommentModal] = useState(false)
  const [invoiceDetailsModal, setInvoiceDetailsModal] = useState(false)

  const isPrivileges_Add = hasPrivilege("Process ECR", "Packages", "Add");
  const isPrivileges_View = hasPrivilege("Process ECR", "Packages", "View");
  const isPrivileges_Edit = hasPrivilege("Process ECR", "Packages", "Edit");
  const isPrivileges_Delete = hasPrivilege("Process ECR", "Packages", "Delete");
  const isPrivileges_Hold = hasPrivilege("Process ECR", "Packages", "Hold");
  const isPrivileges_Cancel = hasPrivilege("Process ECR", "Packages", "Cancel");
  const isPrivileges_Reject = hasPrivilege("Process ECR", "Packages", "Reject");
  const isPrivileges_Review = hasPrivilege("Process ECR", "Packages", "Review");
  const isPrivileges_Verify = hasPrivilege("Process ECR", "Packages", "Verify");
  const isPrivileges_Approve = hasPrivilege("Process ECR", "Packages", "Approve");

  useEffect(() => {
    if (!actionModal && !cancelModal && !deleteConfirmation && !financeLevelModal) {
      if (!filter_data_store?.filter_data) {
        getHotels(pageNumber, searchFilter)
      }
    }
  }, [pageNumber, totalItemPerPage, deleteConfirmation, cancelModal, actionModal, financeLevelModal]) //deleteConfirmation for temprory page refresh handling 

  const getHotels = (pageNumber, filterValue) => {
    const formData = new FormData();
    formData.append('page', pageNumber);
    formData.append('pageItem_count', totalItemPerPage);
    if (filterValue) {
      for (const key in filterValue) {
        formData.append(key, filterValue[key] ?? '');
      }
    }
    getpackage_lists_with_pagination(formData).then((response) => {
      if (response.data.code === 200) {
        setPackageListing(response.data.data)
        setTotalPages(response.data.pagination?.last_page)
      } else {
        setPackageListing([])
        if (pageNumber > 1) {
          setPageNumber(pageNumber - 1)
        }
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  const Columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",

    },
    {
      title: "File Name",
      dataIndex: "filename",
      key: "filename",
    },
    {
      title: "Package Type",
      dataIndex: "ticket_type",
      key: "ticket_type",
    },
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
    },

    {
      title: "Issue Date",
      dataIndex: "issueDate",
      key: "issueDate",
    },
    {
      title: "Hotel",
      dataIndex: "hotel",
      key: "hotel",
    },
    {
      title: "CheckIn",
      dataIndex: "checkIn",
      key: "checkIn",
    },
    {
      title: "CheckOut",
      dataIndex: "checkOut",
      key: "checkOut",
    },
    {
      title: "Service Fee",
      dataIndex: "service_fee",
      key: "service_fee",
    },
    {
      title: "Client",
      dataIndex: "client",
      key: "client",
    },
    {
      title: "Client Amount",
      dataIndex: "client_amount",
      key: "client_amount",
    },
    // {
    //   title: "Gst",
    //   dataIndex: "gst",
    //   key: "gst",
    // },
    // {
    //   title: "Tcs",
    //   dataIndex: "tcs",
    //   key: "tcs",
    // },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",

    },

    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      action: (row) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', 'gap': 5 }} >
            {isPrivileges_View &&
              <IconButton>
                <PiEye className='packages_action_view' onClick={() => {
                  navigate(baseRouteUrl + `/${row.id}/view_package`)
                }} />
              </IconButton>}
            {/* Staff Action handle */}
            {((row.ecr_status == 1 || row.ecr_status == 6) && (isPrivileges_Edit)) ? (
              <>
                <IconButton>
                  <BiEditAlt className='packages_action_edit' onClick={() => {
                    navigate(baseRouteUrl + `/${row.id}/update_package`)
                  }} />
                </IconButton>

                {isPrivileges_Delete && <Tooltip title="Delete" placement="top">
                  <IconButton>
                    <MdOutlineDeleteOutline className='packages_action_delete' onClick={() => {
                      setSelectedId(row.id)
                      setDeleteConfirmation(true)
                    }} />
                  </IconButton>
                </Tooltip>
                }
              </>

            ) : <></>}
            {row.ecr_status == 5 ? (
              <>
                {isPrivileges_Cancel && <Tooltip title="Cancel" placement="top">
                  <IconButton>
                    <IoCloseCircleOutline className='flight_ticket_action_cancel_ticket' onClick={() => {
                      setSelectedItem(row)
                      setCancelModal(true)
                    }} />
                  </IconButton>
                </Tooltip>

                }
              </>
            ) : <></>}
          </div>
          {/* Finance Action handle */}
          {row.ecr_status === 3 || row.ecr_status === 6 ? (
            <>
              {isPrivileges_Hold && <Tooltip title="Hold" placement="top">
                <IconButton onClick={() => {
                  //setfinanceLevelModal old code
                  setActionModal(true)
                  setSelectedItem({ ...row, 'type': 'Hold' })
                }}>
                  <FaRegCirclePause className='flight_ticket_action_onhold' />
                </IconButton>
              </Tooltip>}
            </>
          ) : <></>}

          {row.ecr_status === 3 || row.ecr_status === 7 || row.ecr_status === 6 ? (
            <>
              {isPrivileges_Verify && <Tooltip title="Verify" placement="top">
                <IconButton onClick={() => {
                  setfinanceLevelModal(true)
                  setSelectedItem({ ...row, 'type': 'Verify' })
                }}>
                  <SiTicktick className='flight_ticket_action_verified' />
                </IconButton>
              </Tooltip>}
            </>
          ) : <>
            {/* FOR HANDLE PACKAGE CANCELATION VERIFY BY FINANCE */}
            {row.ecr_status === 11 && isPrivileges_Verify && <Tooltip title="Verify" placement="top">
              <IconButton onClick={() => {
                setfinanceLevelModal(true)
                setSelectedItem({ ...row, 'type': 'CancelVerified' })
              }}>
                <SiTicktick className='flight_ticket_action_verified' />
              </IconButton>
            </Tooltip>}</>}
          {/*Manager Action handle  and also check submitted status  */}
          {(row.ecr_status === 2) ? <>
            {isPrivileges_Review && <Tooltip title="Review" placement="top">
              <IconButton>
                <TiTickOutline className='flight_ticket_action_approve' onClick={() => {
                  setSelectedItem({ ...row, 'type': 'Review' })
                  setActionModal(true)
                }} />
              </IconButton>
            </Tooltip>}
            {isPrivileges_Reject && <Tooltip title="Reject" placement="top">
              <IconButton>
                <IoCloseCircleOutline className='flight_ticket_action_reject' onClick={() => {
                  setSelectedItem({ ...row, 'type': 'Reject' })
                  setActionModal(true)
                }} />
              </IconButton>
            </Tooltip>}

          </> : (row.ecr_status === 10) ? <>
            {/* FOR HANDLE PACKAGE CANCELATION REVIEW BY MANAGER */}
            {isPrivileges_Review && <Tooltip title="Review" placement="top">
              <IconButton>
                <TiTickOutline className='flight_ticket_action_approve' onClick={() => {
                  setSelectedItem({ ...row, 'type': 'CancelReviewed' })
                  setActionModal(true)
                }} />
              </IconButton>
            </Tooltip>}

          </> : <></>}

          {/* //CFO */}
          {(row.ecr_status === 4) ? <>
            {isPrivileges_Approve && <Tooltip title="Approve" placement="top">
              <IconButton>
                <TiTickOutline className='flight_ticket_action_approve' onClick={() => {
                  setSelectedItem({ ...row, 'type': 'Approve' })
                  setActionModal(true)
                  // setCfoLevelModal(true)
                }} />
              </IconButton>
            </Tooltip>}

            {isPrivileges_Reject && <Tooltip title="Reject" placement="top">
              <IconButton>
                <IoCloseCircleOutline className='flight_ticket_action_reject' onClick={() => {
                  setSelectedItem({ ...row, 'type': 'CFOReject' })
                  setActionModal(true)
                  // setCfoLevelModal(true)
                }} />
              </IconButton>
            </Tooltip>}
            {/* FOR HANDLE PACKAGE CANCELATION Approve BY CFO */}
          </> : <>{row.ecr_status === 12 && <>
            {isPrivileges_Approve && <Tooltip title="Approve" placement="top">
              <IconButton>
                <TiTickOutline className='flight_ticket_action_approve' onClick={() => {
                  setSelectedItem({ ...row, 'type': 'CancelApproved' })
                  setActionModal(true)
                }} />
              </IconButton>
            </Tooltip>}</>}</>}
          {true && (
            <IconButton>
              <FaRegCommentAlt className='flight_ticket_action_comment' onClick={() => {
                setSelectedItem({ ...row })
                setcommentModal(true)
              }} />
            </IconButton>
          )}
          {(row.ecr_status === 4 || row.ecr_status === 5 || row.ecr_status === 6 || row.ecr_status === 7 || row.ecr_status === 8) && (row?.invoice?.length !== 0) &&
            <Tooltip title="Invoice" placement="top">
              <IconButton>
                <LiaFileInvoiceSolid className='flight_ticket_action_invoice' onClick={() => {
                  setInvoiceDetailsModal(true)
                  setSelectedItem({ ...row })
                }} />
              </IconButton>
            </Tooltip>
          }

        </div>
      ),
    },
  ];

  const deletePackage = () => {
    if (selectedId) {
      const payload = {
        booking_id: selectedId
      }
      delete_package_by_id(payload).then((response) => {
        if (response.code === 200) {
          handleDeleteModalClose(false)
          SuccessToast(response?.message)
        }
      }).catch((error) => {
        handleDeleteModalClose(false)
        ErrorToast(error?.data?.message)
      })
    }
  }
  const handleDeleteModalClose = (is_close) => {
    setDeleteConfirmation(is_close);
    setSelectedId(null)
  };
  const datas = () => {
    const result =
      packageListing &&
      packageListing?.map((item, index) => {
        return {
          key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
          id: item.booking_id,
          filename: item.filename,
          designation: item.designation,
          issueDate: item.issueDate,
          hotel: item.hotel,
          checkIn: item.checkIn,
          checkOut: item.checkOut,
          // service: item.service,
          service_fee: item.service_fee,
          client: item.client,
          client_amount: item.client_amount,
          gst: item.gst,
          tcs: item.tcs,
          status: item.status,
          ecr_status: item.status_id,
          invoice: item.invoice,
          ticket_type: item.ticket_type,
          is_highlight_row: (item?.status === `Cancelled` || item?.status === `Cancellation Initiated` || item?.status === `Cancellation Reviewed` || item?.status === `Cancellation Verified`) ? true : false,
          highlight_color: item?.status === `Cancelled` || item?.status === `Cancellation Initiated` || item?.status === `Cancellation Reviewed` || item?.status === `Cancellation Verified` ? 'red' : ''

        };
      });
    return result;
  };


  const updatePagination = (pageNumber) => {
    setPageNumber(pageNumber)
  }
  const updateItemPageCount = (pageItemCount) => {
    setTotalItemPerPage(pageItemCount)
  }

  const searchfilter = (value) => {
    setSearchFilter(value)
    if (value) {
      getHotels(pageNumber, value)
    } else {
      getHotels(1, value)
      setPageNumber(1)
    }
    // dispatch(updateSearchFilter({ filename: 'test' }));
    // dispatch(resetSearchFilter())
  }

  const handleModalClose = (is_close) => {
    setCancelModal(is_close)
    setSelectedItem(null)
  };


  //MANAGER LELE MODAL CLOSE
  const handleActionModalClose = (is_close) => {
    setActionModal(is_close)
    setSelectedItem(null)
  };

  const handleActionModalCloseForDashBoard = (is_close) => {
    setActionModal(is_close)
    setSelectedItem(null)
  }; 
  const handleFinanceLevelModalClose = (is_close) => {
    setfinanceLevelModal(is_close)
    setSelectedItem(null)
  };
  const handleCfoLevelModalClose = (is_close) => {
    setCfoLevelModal(is_close)
    setSelectedItem(null)
  };
  const handleCommentModalClose = (is_close) => {
    setcommentModal(is_close)
    setSelectedItem(null)
  };

  const handleInvoiceDetailsModalClose = (is_close) => {
    setInvoiceDetailsModal(is_close)
    setSelectedItem(null)
  };

  return (

    <div className='packages_module_main_container'>
      <p className='packages_title'>Packages</p>
      <div>

        <div className='user_module_filter'>
          <PackagesFilter searchFilter={searchfilter} />
          {isPrivileges_Add && <button className='packages_add_button' onClick={() => {
            navigate(baseRouteUrl + `/create_new_package`)
          }}>Add New</button>}
        </div>
        <div className='packages_table_main_container'>
          <CustomTable columns={Columns} rows={datas()} />
        </div>
        <div>
          <CustomBottomPagination total_items_per_page={totalItemPerPage} total_page_count={totalPages} current_page={pageNumber} on_change_value={updatePagination} on_page_count_update={updateItemPageCount} />
        </div>
      </div>
      <CustomDeleteConfirmModal module_name={'Packages'} open_modal={deleteConfirmation} close_modal={handleDeleteModalClose} confirm_function={deletePackage} />
      <CancelPackages selected_item={selectedItem} open_modal={cancelModal} modal_close={handleModalClose} />
      <PackageReusableModals selected_item={selectedItem} open_modal={actionModal} modal_close={handleActionModalClose} />
      <PackageCommentModal open={commentModal} handleClose={handleCommentModalClose} booking_id={selectedItem?.id} />

      {/* <PackagesManagerLevelModal selected_item={selectedItem} open_modal={actionModal} modal_close={handleActionModalClose} /> */}
      <PackageFinanceLevelModals selected_item={selectedItem} open_modal={financeLevelModal} modal_close={handleFinanceLevelModalClose} />
      {invoiceDetailsModal && <PackageInvoiceDetailsModal selected_item={selectedItem} open_modal={invoiceDetailsModal} modal_close={handleInvoiceDetailsModalClose} />}

    </div>
  )
}

export default Packages